import React from 'react';
import { View } from 'react-native';
import PlatformAdminScreenEnhanced from '@/screens/admin/PlatformAdminScreenEnhanced';
import { useTabAccess } from '@/hooks/useTabAccess';
import {
  AdminSectionCard,
  ADMIN_COLORS,
} from '@/components/admin/AdminUI';
import { WebAppShell } from '@/design-system/components';

export const options = {
  headerShown: false,
};

export default function MorePlatformAdminScreen() {
  const { showPlatformAdmin, user } = useTabAccess();

  if (!showPlatformAdmin) {
    return (
      <WebAppShell active="platform-admin" contentMaxWidth="100%" scroll={false}>
        <View style={{ padding: 24 }}>
          <AdminSectionCard
            icon="lock"
            iconBg={ADMIN_COLORS.errorSoft}
            iconColor={ADMIN_COLORS.errorText}
            title="Restricted to super administrators"
            subtitle="Platform admin tools manage the entire platform: schools, billing, AI models, and global settings. Only super-admin accounts can open them."
          />
        </View>
      </WebAppShell>
    );
  }

  return (
    <WebAppShell active="platform-admin" contentMaxWidth="100%" scroll={false}>
      <PlatformAdminScreenEnhanced user={user ?? undefined} />
    </WebAppShell>
  );
}
